import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";








import { PrimaryTimberStorage } from "../../../../timber/types/models/TimberStorage";

import TimberStorageFormSelect from "../../../../timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect";

import { useGetTimberStorageQuery } from "../../../../timber/apis/TimberStorage.api";

import TimberTypeFormSelect from "../../../../timber/components/timberType/TimberTypeForm/TimberTypeFormSelect";









import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";














export const initialFormStateFn = () => { return {
    
        
        storageId: null,
        
    
        
        timberTypeId: null,
        
    
        
        volume: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.storageId = PrimaryTimberStorage.fromQuery(location.state?.timberStorageId) || null;
    

    const { data: storageIdData } = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(initialFormState.storageId), { skip: !initialFormState.storageId })
    

    return React.useMemo(() => initialFormState, [
        location.state,
        storageIdData,
        
        
    ])
}

export const formObject = {
    
    
        storageId:
        string()
                .nanoid(msg`Storage is required`)
                .min(1, msg`Storage is required`),
    
    
        timberTypeId:
        string()
                .nanoid(msg`Timber Type is required`)
                .min(1, msg`Timber Type is required`),
    
    
        volume:
        number()
                 .gt(0).transform((value) => (!value ? null : value))
                .and(coerce.number(msg`must be a number.`)),
    
};

export const formSchema = object(formObject);

const TreeMarkingAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <TimberStorageFormSelect
        type="dynamicSelect"
        name="storageId"
        label={t`Storage`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <TimberTypeFormSelect
        type="select"
        name="timberTypeId"
        label={t`Timber Type`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'volume' }
       aria-label="volume"
       data-testid="volume"
       label={t`Volume (m&#xB3;)`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
           
        </Container>
    )
}

export default TreeMarkingAddForm;
